import { fireLoginHandlers } from '../../utils/loginHandlers';
import { trackRegistrationComplete } from './authTracking';
import { reportRegisterAction } from '../helpers/newRelicActions';
import { setTokens, updateProfile } from './userStorageActions';
import { isEmailOnlyUserToken } from 'dibs-cookie-jar/exports/isEmailOnlyUserToken';

export function authTrackingHandler({ userRegistration, ga, environment }) {
    trackRegistrationComplete({ ...userRegistration, ...ga });

    const { user, emailToken, userToken } = userRegistration;
    const isEmailOnlyRegistration = isEmailOnlyUserToken({ userToken, emailToken });
    setTokens({
        environment,
        ...userRegistration,
    });

    updateProfile({ environment, ...userRegistration }).then(() => {
        fireLoginHandlers(userRegistration);
    });

    reportRegisterAction({
        user,
        source: '1stdibs',
        emailOnly: isEmailOnlyRegistration,
    });
}
